
    import Component from "vue-class-component";
    import Vue from "vue";
    import {Prop} from "vue-property-decorator";
    import {ApplicationActions} from "@/api-client";

    @Component
    export default class IssueDocumentAsideActions extends Vue {
        @Prop({required: true})
        actions!: ApplicationActions;
    }
